import { useLingui } from "@lingui/react/macro";
import { FilterBanner } from "@/components/FilterBanner/FilterBanner";
import {
  useEmployeeNameFilterActions,
  useShiftsFilterBannerItem,
} from "./ShiftsContext";

export const ShiftsFilterBannerSection = () => {
  const { t } = useLingui();
  const employeeNameFilterItem = useShiftsFilterBannerItem(
    t({ message: `Medarbetare`, context: "singular" }),
  );
  const { clearFilterValue } = useEmployeeNameFilterActions();

  return (
    <FilterBanner
      filters={[employeeNameFilterItem]}
      onClearAllFilters={clearFilterValue}
    />
  );
};
